import React from "react"
import RPMFollowUpQuesView from "./RPMFollowUpQuesView"

const RPMFollowUpView = () => <RPMFollowUpQuesView />

export default RPMFollowUpView
